<div class="customize-footer"
  [ngClass]="{'customize-footer--white-design': configureOptions.footerDesignType === 1,
    'customize-footer--black-design': configureOptions.footerDesignType === 2,
    'customize-footer--black-ratio': configureOptions.footerDesignType === 3 && customizeFooter.ratio === 'black'}">
  <div class="customize-footer__container"
    [ngClass]="{'customize-footer__container--white-design': configureOptions.footerDesignType === 1 }"
    id="customize-footer">
    @if (configureOptions.showLogoInFooter) {
      <div class="customize-footer__logo-container">
          <img class="customize-footer__logo-img"
            [src]="configureOptions.logoFooter"
            alt="logo footer"/>
      </div>
    }
    <div class="customize-footer__social-contact-container">
      @if(configureOptions.defaultCustomization){
        <div class="customize-footer__description-text">
          @if(configureOptions.companyInfo){
            <span>{{configureOptions.companyInfo}}</span>
          }
          @for (legalInfo of configureOptions.legalInfoLinks; track legalInfo.id){
            <a class="centinela-footer__legal-container-inner-link"
              [href]="legalInfo.href"
              target="_blank">{{legalInfo.name}}</a>
            @if(!$last){
              <span>{{configureOptions.separator}}</span>
            }
          }
        </div>
      }@else if (configureOptions.footerDescription) {
        <div class="customize-footer__description-text"
          [innerHTML]="configureOptions.footerDescription"></div>
      }
      @if (configureOptions.phone) {
        <div class="customize-footer__phone-container">
          <i class="lf-icon-call customize-footer__icon-call"></i>
          <span>{{configureOptions.phone}}</span>
        </div>
      }
      @if (customizeFooter.hasRrss) {
        <div class="customize-footer__rrss-container">
          @for (socialNetwork of customizeFooter.rrss; track socialNetwork.key){
            <a [href]="socialNetwork.url"
              target="_blank"
              class="customize-footer__link-social-network">
              <i [class]="'lf-icon-'+socialNetwork.key+'-round'"
                [ngClass]="{'customize-footer__icon-social-network-white': configureOptions.footerDesignType === 2 || customizeFooter.ratio === 'white',
                'customize-footer__icon-social-network-black': configureOptions.footerDesignType === 1 || customizeFooter.ratio === 'black'}"></i>
            </a>
          }
        </div>
      }
    </div>
  </div>
  @if (configureOptions.footerDesignType === 1) {
    <div class="customize-footer__border-bottom"
      [ngClass]="{'customize-footer__border-bottom--gradient': configureOptions.secondaryColor}"></div>
  }
</div>
